import { QueryClient } from 'react-query';
import { ownerUnbookableDatesQueryKey } from '@alluradirect/react';

export function generateQueryClient(): QueryClient {
  const client = new QueryClient({
    defaultOptions: {
      queries: {
        useErrorBoundary: true,
      },
    },
  });

  client.setQueryDefaults(ownerUnbookableDatesQueryKey.all, {
    staleTime: Infinity,
    cacheTime: Infinity,
  });

  return client;
}
